import styled from "styled-components";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

export const StyledAppBar = styled(AppBar)`
  background-color: ${({ theme }) => theme.palette.redesign.navbarBg} !important;
  backdrop-filter: ${({ transparent }) =>
    transparent ? "none" : "blur(14px)"} !important;
  -webkit-backdrop-filter: ${({ transparent }) =>
    transparent ? "none" : "blur(14px)"} !important;
  box-shadow: ${({ transparent }) =>
    transparent
      ? "none"
      : "0 1px 0 rgba(0, 0, 0, 0.06)"} !important;
  transition: background-color 0.35s ease, backdrop-filter 0.35s ease,
    -webkit-backdrop-filter 0.35s ease, box-shadow 0.35s ease !important;
  width: 100%;
  box-sizing: border-box;
  max-width: 1560px;
  margin: 0 auto;
  padding: 0 3rem;
  top: 0; /* margin from the top */
  left: 0 !important;
  right: 0 !important;
  z-index: 1100;
  height: 7rem;

  .MuiContainer-root {
    padding: 0;
    max-width: 100%;
    margin: 0 auto;
  }

  .MuiToolbar-root {
    min-height: 6.5rem !important;
    height: 6.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  ${({ theme }) => theme.breakpoints.down("sm")} {
    max-width: 100%;
    position: fixed;
    top:0;
    z-index: 1100;
    background-color:  ${({ theme }) => theme.palette.redesign.navbarBg} !important;
    backdrop-filter: none !important;
    -webkit-backdrop-filter: none !important;
    box-shadow: none !important;
    margin: 0;
    padding: 0 1rem;
    height: 3.5rem;

    .MuiContainer-root {
      padding: 0;
    }
    .MuiToolbar-root {
      min-height: 3.5rem !important;
      height: 3.5rem;
      gap: 0.75rem;
    }
    .MuiButtonBase-root {
      padding: 0;
    }
  }
`;

/* ── Desktop nav links container ────────────────────────────── */
export const DesktopMenuContainer = styled(Box)`
  display: none;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  gap: 2.5rem;

  ${({ theme }) => theme.breakpoints.up("sm")} {
    display: flex;
  }
  ${({ theme }) => theme.breakpoints.up("laptopL")} {
    gap: 3rem;
  }
`;

/* ── Individual desktop nav link ────────────────────────────── */
export const DesktopMenuItem = styled(MenuItem)`
  color: white;
  display: block;
  text-transform: capitalize;
  padding: 0 0.25rem;
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: 400;
  font-size: 1.25rem;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: 0.02em;
  background: none !important;
  position: relative;

  /* Subtle underline on hover */
  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 1.5px;
    background: ${({ theme }) => theme.palette.redesign.pink} !important;
    transition: width 0.25s ease;
  }
  &:hover::after {
    width: 100%;
  }
  &:hover {
    background: none !important;
    color: ${({ theme }) => theme.palette.redesign.pink};
  }

  /* Override link colours from global CustomLink */
  a {
    color: white !important;
    &:hover {
      color: ${({ theme }) => theme.palette.redesign.pink} !important;
  }
}

  ${({ theme }) => theme.breakpoints.up("laptopL")} {
    font-size: 1.625rem;
  }
`;

/* ── Mobile hamburger container ────────────────────────────── */
export const MobileMenuContainer = styled(Box)`
  justify-content: flex-start;
  display: flex;

  /* Tint the hamburger icon */
  .MuiIconButton-root {
    color: ${({ theme }) => theme.palette.redesign.pink};
  }

  ${({ theme }) => theme.breakpoints.up("sm")} {
    display: none;
  }
`;

/* ── Mobile dropdown menu ──────────────────────────────────── */
export const MobileMenu = styled(Menu)`
  display: block;
  .MuiMenu-paper {
    padding: 0.5rem 0.75rem;
    margin-top: 0.25rem;
    border-radius: 0.75rem;
    background-color: ${({ theme }) => theme.palette.redesign.white};
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
    color: ${({ theme }) => theme.palette.redesign.pink} !important;

    .MuiList-root {
      padding: 0;
    }
  }
  ${({ theme }) => theme.breakpoints.up("sm")} {
    display: none;
  }
`;

/* ── Mobile menu item ──────────────────────────────────────── */
export const MobileMenuItem = styled(MenuItem)`
  color: ${({ theme }) => theme.palette.redesign.navbarText};
  display: block;
  text-transform: capitalize;
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: 400;
  font-size: 0.875rem;
  min-height: 0;
  padding: 0.6rem 1rem;

  &:not(:last-child) {
    border-bottom: 1px solid rgba(48, 80, 43, 0.12);
  }
  &:hover {
    background: rgba(48, 80, 43, 0.06) !important;
  }

  /* Override link colour for mobile */
  a {
    color: ${({ theme }) => theme.palette.redesign.navbarText} !important;
    &:hover {
      color: ${({ theme }) => theme.palette.redesign.pink} !important;
    }
  }
`;

/* ── Logo ──────────────────────────────────────────────────── */
export const Logo = styled.img`
  width: 7rem;
  height: auto;
  padding : 0.4rem;
  border-radius: 2rem;

  ${({ theme }) => theme.breakpoints.up("sm")} {
    width: 14rem;
    height: auto;
    padding : 0;   
    background : transparent !important;
  }
`;

export const LoginButton = styled.button`
  display: inline-flex;
  align-items: center;
  background: none;
  border: none;
  padding: 0;
  color: #fff;
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: 500;
  font-size: 1.375rem;
  letter-spacing: 0.01em;
  cursor: pointer;
  white-space: nowrap;
  margin-right: 1.25rem;

  &:hover {
    color: ${({ theme }) => theme.palette.redesign.pink};
  }

  ${({ theme }) => theme.breakpoints.down("sm")} {
    display: none;
  }
`;

export const CTAButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1.25rem 0.625rem 1.25rem;
  border: none;
  border-radius: 999px;
  background: ${({ theme }) => theme.palette.redesign.pink};
  color: ${({ theme }) => theme.palette.primary.contrastText};
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: 500;
  font-size: 1.375rem;
  letter-spacing: 0.01em;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s ease, transform 0.15s ease;

  &:hover {
    background: ${({ theme }) => theme.palette.primary.light};
  }
  &:active {
    transform: scale(0.97);
  }

  ${({ theme }) => theme.breakpoints.down("sm")} {
    display: none;
  }
`;
